import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import NumberInput from '../../controls/numberInput';
export default class TankShell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diameter: '',
      height: '',
      amount: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAmount = this.handleChange.bind(null, 'amount');
    this.handleChangeDiameter = this.handleChange.bind(null, 'diameter');
    this.handleChangeHeight = this.handleChange.bind(null, 'height');
  }
  handleChange(key, value) {
    const {
      onCalc
    } = this.props;
    this.setState({
      [key]: value
    }, () => {
      const {
        diameter,
        height,
        amount
      } = this.state;
      if (diameter !== '' && height !== '' && amount !== '') {
        // Calculate the surface area
        const total = 3.14 * diameter * height * amount;

        // If it's a valid value, pass it up
        if (!_.isNaN(total)) {
          onCalc(+total.toFixed(2));
        }
      }
    });
  }
  render() {
    const {
      diameter,
      height,
      amount
    } = this.state;
    const {
      result
    } = this.props;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, {
      style: {
        textAlign: 'center',
        marginBottom: '20px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("i", null, "3.14 x Diameter x Height x Amount = Surface Area"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Diameter",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeDiameter,
      value: diameter
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Height",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeHeight,
      value: height
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Amount",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeAmount,
      value: amount
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      disabled: true,
      value: result || ''
    })))));
  }
}
TankShell.defaultProps = {
  onCalc: null,
  result: null
};
TankShell.propTypes = {
  onCalc: PropTypes.func,
  result: PropTypes.number
};